import { render } from "./JuiceComponent.vue?vue&type=template&id=6161907c"
import script from "./JuiceComponent.vue?vue&type=script&lang=js"
export * from "./JuiceComponent.vue?vue&type=script&lang=js"

import "./JuiceComponent.vue?vue&type=style&index=0&id=6161907c&lang=css"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__